import { makeStyles } from '@mui/styles';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: { padding: '2rem' },
    sectionContainer: {
        marginBottom: '16px',
        '&:last-child': { marginBottom: 0 }
    },
    headerText: {
        fontSize: '12px',
        textTransform: 'uppercase' as const,
        color: theme?.app?.clientTheme.colors.primaryColor || '#3C4F70'
    }
}));